import React, {useMemo, useState, useEffect} from "react"
import PropTypes from "prop-types"
import ReactInputMask from "react-input-mask"
import TextFieldInput from "../text-field-input"
import {parseDate} from "../../../utils/validate-date/parse-date"

const DATE_MASK = "99/99/9999"

const DateMaskedInput = ({value, minDate, maxDate, onChange, onBlur, disabled, ...rest}) => {
    const [error, setError] = useState("")
    const [touched, setTouched] = useState(false)

    const mask = useMemo(() => DATE_MASK, [])

    useEffect(() => {
        const raw = value || ""
        if (!raw || raw.length < DATE_MASK.length) {
            setError(touched && raw ? "Data incompleta" : "")
            return
        }
        const date = parseDate(raw)
        if (!date) {
            setError("Data inválida")
            return
        }
        const min = minDate ? parseDate(minDate) : null
        const max = maxDate ? parseDate(maxDate) : null
        if (min && date < min) {
            setError("Data abaixo do mínimo")
            return
        }
        if (max && date > max) {
            setError("Data acima do máximo")
            return
        }
        setError("")
    }, [value, minDate, maxDate, touched])

    const handleBlur = (event) => {
        setTouched(true)
        if (onBlur) onBlur(event)
    }

    return (
        <ReactInputMask mask={mask} value={value} onChange={onChange} onBlur={handleBlur} maskChar="" disabled={disabled}>
            {(inputMaskProps) => (
                <TextFieldInput
                    {...rest}
                    value={value}
                    onChange={onChange}
                    error={Boolean(error)}
                    helperText={error || undefined}
                    {...inputMaskProps}
                    InputLabelProps={rest.InputLabelProps}
                />
            )}
        </ReactInputMask>
    )
}

DateMaskedInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
}

export default DateMaskedInput
